import { RealEstateUser } from '@arpada/arp-lib-common-qupro';
export class RealEstateExtendedData {
    public realEstate: RealEstateUser;
}
